/*
 * @Author       : 蔡韬
 * @Date         : 2020-09-14 14:48:52
 * @LastEditors: chenxu24
 * @LastEditTime: 2022-12-19 17:03:58
 * @FilePath     : \portal\src\views\company\const.js
 */
const JOB_TITLES = [
  {
    value: 'finance',
    label: 'finance'
  },
  {
    value: 'human_resource',
    label: 'human_resource'
  },
  {
    value: 'installation_and_maintenance',
    label: 'installation_and_maintenance'
  },
  {
    value: 'procurement',
    label: 'procurement'
  },
  {
    value: 'sales',
    label: 'sales'
  },
  {
    value: 'techinical_support',
    label: 'techinical_support'
  },
  {
    value: 'HPP-web_company_auth_general_manager',
    label: 'HPP-web_company_auth_general_manager'
  }
];

const AUTH_STATE = {
  UN_AUTH: 0, // 未认证
  CODE_AUTH: 1, // 认证码认证成功
  MANUAL_AUTH: 2, // 人工认证成功
  WAIT_AUTH: 3, // 待认证
  FAIL_AUTH: 4, //认证失败
  NO_DEVICE_AUTH: 5 //等待添加设备
};

let ACCOUNT_TYPE;
(function (map) {
  map[(map['INSTALLERS'] = 0)] = 'account_type_1';
  map[(map['SYSTEM_INTEGRATOR'] = 1)] = 'account_type_2';
  map[(map['CALL_CENTER'] = 2)] = 'account_type_3';
  map[(map['END_USER'] = 3)] = 'account_type_4';
  map[(map['IT_STAFF'] = 4)] = 'account_type_5';
  map[(map['OTHER'] = 5)] = 'others';
  map[(map['DISTRIBUTOR'] = 6)] = 'label_distributor';
  map[(map['RESELLER'] = 7)] = 'label_reseller';
  map[(map['OEM'] = 8)] = 'account_type_oem';
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));

let ACCOUNT_TYPE_EP;
(function (map) {
  map[(map['other'] = 0)] = 'others';
  map[(map['DISTRIBUTOR'] = 1)] = 'label_distributor';
  map[(map['RESELLER'] = 2)] = 'label_reseller';
  map[(map['INSTALLER'] = 4)] = 'account_type_1';
  map[(map['ARCHITECTS_ENGINEERS_CONSULTANT'] = 5)] = 'ARCHITECTS_ENGINEERS_CONSULTANT';
  map[(map['SYSTEM_INTEGRATOR'] = 6)] = 'account_type_2';
  map[(map['END_USER'] = 7)] = 'device_resetpin_endUser';
  map[(map['OEM'] = 8)] = 'label_OEM';
  map[(map['GENERAL_CONTRACTOR'] = 9)] = 'GENERAL_CONTRACTOR';
  map[(map['OTHERS'] = 10)] = 'others';
  map[(map['RETAILER'] = 11)] = 'RETAILER';
  map[(map['WHOLESALER'] = 12)] = 'WHOLESALER';
  map[(map['arc_center'] = 13)] = 'arc_center';
  map[(map['IT_STAFF'] = 14)] = 'account_type_5';
})(ACCOUNT_TYPE_EP || (ACCOUNT_TYPE_EP = {}));

let ACCOUNT_TYPE_DATA = [
  {
    show: true,
    select: true,
    key: ACCOUNT_TYPE.INSTALLERS,
    label: ACCOUNT_TYPE[ACCOUNT_TYPE.INSTALLERS],
    desc: 'account_type_desc_1',
    descTip: 'account_type_desc_tip',
    icon: 'icon_account_1'
  },
  {
    show: true,
    select: true,
    key: ACCOUNT_TYPE.SYSTEM_INTEGRATOR,
    label: ACCOUNT_TYPE[ACCOUNT_TYPE.SYSTEM_INTEGRATOR],
    desc: 'account_type_desc_2',
    icon: 'icon_account_2'
  },
  {
    show: true,
    select: true,
    cantChoose: true,
    key: ACCOUNT_TYPE.DISTRIBUTOR,
    label: ACCOUNT_TYPE[ACCOUNT_TYPE.DISTRIBUTOR],
    desc: 'account_type_desc_7',
    icon: 'icon_account_7'
  },
  {
    show: true,
    select: true,
    key: ACCOUNT_TYPE.RESELLER,
    label: ACCOUNT_TYPE[ACCOUNT_TYPE.RESELLER],
    desc: 'account_type_desc_8',
    icon: 'icon_account_5'
  },
  {
    show: true,
    select: true,
    key: ACCOUNT_TYPE.CALL_CENTER,
    label: ACCOUNT_TYPE[ACCOUNT_TYPE.CALL_CENTER],
    desc: 'account_type_desc_3',
    descTip: 'account_type_desc_tip',
    icon: 'icon_account_3'
  },
  {
    show: true,
    select: true,
    key: ACCOUNT_TYPE.OEM,
    label: ACCOUNT_TYPE[ACCOUNT_TYPE.OEM],
    desc: 'account_type_oem_desc',
    icon: 'icon_account_8'
  },
  {
    show: false,
    select: true,
    key: ACCOUNT_TYPE.END_USER,
    label: ACCOUNT_TYPE[ACCOUNT_TYPE.END_USER],
    desc: 'account_type_desc_4',
    icon: 'icon_account_4'
  },
  {
    show: false,
    select: false,
    key: ACCOUNT_TYPE.IT_STAFF,
    label: ACCOUNT_TYPE[ACCOUNT_TYPE.IT_STAFF],
    desc: 'account_type_desc_5',
    icon: 'icon_account_5'
  },
  {
    show: false,
    select: false,
    key: ACCOUNT_TYPE.OTHER,
    label: ACCOUNT_TYPE[ACCOUNT_TYPE.OTHER],
    desc: '',
    icon: 'icon_account_6'
  }
];

const IT_SYSTEM = [ACCOUNT_TYPE.END_USER, ACCOUNT_TYPE.IT_STAFF];
const ACCOUNT_PRODUCT_TYPE = [
  { value: 0, label: 'auth_product_option_0' },
  { value: 1, label: 'auth_product_option_1' },
  { value: 2, label: 'auth_product_option_2' },
  { value: 3, label: 'auth_product_option_3' },
  { value: 4, label: 'auth_product_option_4' },
  { value: 5, label: 'auth_product_option_5' },
  { value: 6, label: 'auth_product_option_6' },
  { value: 7, label: 'auth_product_option_7' },
  { value: 8, label: 'auth_product_option_8' },
  { value: 9, label: 'auth_product_option_9' }
];

const FILTER_US_ACCOUNT_TYPE = [ACCOUNT_TYPE.OEM, ACCOUNT_TYPE.RESELLER];
export {
  JOB_TITLES,
  AUTH_STATE,
  ACCOUNT_TYPE,
  ACCOUNT_TYPE_EP,
  ACCOUNT_TYPE_DATA,
  ACCOUNT_PRODUCT_TYPE,
  IT_SYSTEM,
  FILTER_US_ACCOUNT_TYPE
};
